import type { EnterFrom } from '~/params'
import type { FeaturesPageVariant } from '~/features/multi-page/components/features-page'

export function getFeaturesPageVariant({
  enterFrom,
  isChinaRegion,
  isProUser,
}: {
  enterFrom: EnterFrom | null
  isChinaRegion: boolean
  isProUser: boolean
}): FeaturesPageVariant {
  // The shop entry outranks pro standing: it always leads with the coin
  // scene, unlike the legacy coin-boost entries below.
  if (enterFrom === 'shop') {
    return isProUser ? 'pro_coin_3x' : 'coin_3x'
  }
  if (isProUser) {
    return isChinaRegion ? 'pro_china' : 'pro_others'
  }
  switch (enterFrom) {
    case 'focus_settings_exclusive_trees':
      return isChinaRegion ? 'cn_region_trees' : 'others_trees'
    case 'home_coin_boost':
    case 'store_coin_boost':
    case 'insufficient_coins':
    case 'focus_result_boost':
      return 'coin_3x'
    case 'real_tree':
      return 'real_tree'
    default:
      return isChinaRegion ? 'cn_region_default' : 'others_default'
  }
}
